const {Component} = require("react");
const PropTypes = require("prop-types");
const env = require("services/env");
const Tags = require("components/forms/Tags");
const {classList} = require("helpers/html");
const SubjectPicker = require("components/widgets/SubjectPicker");
const CheckboxGroup = require("components/forms/CheckboxGroup");
const InclusiveCheckbox = require("components/forms/InclusiveCheckbox");

function getSubjectsPool(levels) {
	return levels.reduce((acc, level) => acc.concat(level.subjects.filter(subjectId => acc.indexOf(subjectId) === -1)), []);
}

function getIntersectedSubjects(levels, subjects) {
	const pool = getSubjectsPool(levels);
	return subjects.filter(subject => pool.indexOf(subject.id) !== -1);
}

function getIntersectedLevels(levels, subjects) {
	return levels.filter(level => {
		for (let i = 0; i < level.subjects.length; i++) {
			if (subjects.findIndex(subject => subject.id === level.subjects[i]) !== -1) {
				return true;
			}
		}

		return false;
	});
}

class Qualifications extends Component {

	static get propTypes() {
		return {
			levels: PropTypes.array,
			subjects: PropTypes.array,
			levelsError: PropTypes.any,
			subjectsError: PropTypes.any,
			afterChange: PropTypes.func,
		};
	}

	static get defaultProps() {
		return {
			levels: [],
			subjects: []
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			levels: props.levels,
			subjects: getIntersectedSubjects(props.levels, props.subjects)
		};
	}

	componentDidUpdate(prevProps, prevState) {
		const levelsChanged = this.state.levels !== prevState.levels;
		const subjectsChanged = this.state.subjects !== prevState.subjects;

		if (levelsChanged || subjectsChanged) {
			this.afterChange();
		}
	}

	get levelsPool() {
		return env.get("options.levels", []);
	}

	get entireSubjectsPool() {
		return env.get("options.subjects", []);
	}

	get subjectsPool() {
		const subjects = this.entireSubjectsPool;
		return getSubjectsPool(this.state.levels).map(subjectId => {
			return subjects.filter(subject => subject.id === subjectId) [0];
		});
	}

	get required() {
		return this.props.required === true;
	}

	handleLevelsChange = (id, selected) => {
		let all = this.levelsPool;
		let levels = this.state.levels;

		// remove deselected
		if (! selected) {
			levels = levels.filter(l => l.id !== id);

		// add selected
		} else {
			levels.push(all.find(l => l.id === id));
		}

		this.onLevelsChange(levels);
	}

	afterChange = () => {
		if (typeof this.props.afterChange === 'function') {
			this.props.afterChange();
		}
	}

	onLevelsChange = (value) => {
		this.setState({
			levels: value,
			subjects: getIntersectedSubjects(value, this.state.subjects)
		});
	};

	onSubjectsChange = (value) => {
		this.setState({
			subjects: getIntersectedSubjects(this.state.levels, value)
		});
	};

	onBrowseSubjects = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.picker.open();
	};

	handlePickerChange = (subjects) => {
		this.setState({
			subjects: subjects,
			levels: getIntersectedLevels(this.levelsPool, subjects)
		});
	};

	renderPicker() {
		return (
			<div className="subject-picker-wrapper">
				<p>Gennemse alle niveauer og fag og vælg hvad du gerne vil undervise i</p>
				<button type="button" className="btn" onClick={this.onBrowseSubjects}>Vælg...</button>
				<SubjectPicker ref={el => this.picker = el}
											 handleChange={this.handlePickerChange}
											 levelsPool={this.levelsPool}
											 subjectsPool={this.entireSubjectsPool}
											 subjects={this.state.subjects}/>
			</div>
		);
	}

	renderCheckboxGroup() {
		return (
			<CheckboxGroup label="Hvilke niveauer vil du gerne undervise" required={this.required} error={this.props.levelsError}>
				{this.levelsPool.map((level, index) => (
					<InclusiveCheckbox
						key={index}
						label={level.name}
						name="levels[]"
						value={level.id}
						checked={this.state.levels.find(l => l.id === level.id) ? true : false}
						handleChange={this.handleLevelsChange}
					/>
				))}
			</CheckboxGroup>
		);
	}

	render() {
		return (
			<div className={classList("field qualifications-fields", this.props.className)}>
			
				{this.renderPicker()}
				{this.renderCheckboxGroup()}

				<Tags className="full-width" label="Fag" name="subjects" required={this.required}
							error={this.props.subjectsError}
							pool={this.subjectsPool} value={this.state.subjects} handleChange={this.onSubjectsChange}/>
			</div>
		);
	}

}

module.exports = Qualifications;



// WEBPACK FOOTER //
// ./resources/js/components/forms/Qualifications.js